// extracted by mini-css-extract-plugin
export var boxItems = "_6o-1";
export var button = "_6o-5";
export var filterGroupBox = "_6o-0";
export var icon = "_6o-2";
export var iconSecondary = "_6o-4";
export var iconWrapper = "_6o-3";